// Transforms a pair of mount/unmount functions to use a reference counter.
// Useful for managing React components that depend on global state.
//
// For more about the reference counter pattern, see:
//   https://en.wikipedia.org/wiki/Reference_counting
var withReferenceCounter = function withReferenceCounter(_ref) {
  var _mount = _ref.mount,
      _unmount = _ref.unmount;
  var referenceCount = 0;
  return {
    mount: function mount() {
      referenceCount = Math.max(referenceCount + 1, 0);

      if (referenceCount === 1) {
        _mount();
      }
    },
    unmount: function unmount() {
      if (referenceCount === 1) {
        _unmount();
      }

      referenceCount = Math.max(referenceCount - 1, 0);
    }
  };
};

export default withReferenceCounter;